// Editorial cluster — průvodce s Article schema, autorem a daty.
export const GUIDES = [
  {
    slug: "kolik-stoji-teambuilding",
    path: "/pruvodce/kolik-stoji-teambuilding",
    title: "Kolik stojí firemní teambuilding? Reálné ceny 2026",
    description: "Kolik stojí firemní teambuilding pro 20, 30 nebo 50 lidí? Konkrétní ceny, co je v balíčku a na co si dát pozor při porovnávání nabídek.",
    h1: "Kolik stojí firemní teambuilding?",
    excerpt: "Konkrétní ceny teambuildingu pro 20–50 lidí, co je v balíčku a jak číst nabídky agentur.",
    author: "Tým Extreme Teambuilding",
    publishedAt: "2026-06-01",
    updatedAt: "2026-06-10",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Průvodce", href: "/pruvodce" },
      { label: "Kolik stojí teambuilding", href: "/pruvodce/kolik-stoji-teambuilding" },
    ],
    sections: [
      {
        heading: "Krátká odpověď",
        paras: [
          "Kvalitní celodenní firemní teambuilding v ČR stojí typicky 1 500–3 000 Kč na osobu bez ubytování a 4 000–8 000 Kč na osobu s ubytováním, jídlem a večerním programem. U Mission Ještěd: jednodenní Mission od 2 490 Kč na osobu, Mission 24 od 4 990 Kč na osobu (minimální cena akce 129 000 Kč).",
        ],
      },
      {
        heading: "Cena podle počtu lidí — náš reálný příklad",
        paras: [
          "Cena teambuildingu klesá s počtem účastníků, protože fixní náklady (venue, instruktoři, DJ, fotograf) se rozpočítávají. Příklad Mission 24:",
          "20 lidí: 129 000 Kč (6 450 Kč/os.). 30 lidí: 169 000 Kč (5 633 Kč/os.). 40 lidí: 209 000 Kč (5 225 Kč/os.). 50 lidí: 249 000 Kč (4 980 Kč/os.). Ceny jsou orientační — finální nabídka závisí na termínu a konfiguraci.",
        ],
      },
      {
        heading: "Co musí být v ceně (a co bývá navíc)",
        paras: [
          "V ceně Mission 24 je: mise s organizací a instruktory, 1 noc ubytování, doprava v místě, lunch/snack, finish drink, večeře, soukromý Warehouse s DJ, fotograf a snídaně.",
          "Navíc se typicky platí: doprava z vašeho města (umíme zajistit autobus door-to-door), open bar, premium catering, aftermovie, live band nebo moderátor.",
        ],
      },
      {
        heading: "Na co si dát při porovnávání nabídek pozor",
        paras: [
          "Porovnávejte vždy cenu za celou akci, ne jen osoboden. Levná nabídka bez venue, jídla a koordinátora se nakonec prodraží — a hlavně ji musí koordinovat někdo z vaší firmy.",
          "Ptejte se na minimální cenu akce, storno podmínky a co se stane při dešti. U Mission Ještěd má každá akce weather plan, takže se neruší — přizpůsobí se.",
        ],
      },
    ],
    cta: { heading: "Chcete nezávaznou kalkulaci?", text: "Stačí počet lidí, termín a rozpočet. Návrh mise připravíme na míru." },
    related: [
      { href: "/cenik", title: "Ceník", text: "Balíčky Mission, Mission 24 a Mission Weekend." },
      { href: "/pruvodce/teambuilding-pro-30-lidi-priklad", title: "Teambuilding pro 30 lidí", text: "Kompletní příklad programu a rozpočtu." },
      { href: "/pruvodce/jak-naplanovat-firemni-teambuilding", title: "Jak naplánovat firemní teambuilding", text: "Krok za krokem od briefu po akci." },
    ],
  },
  {
    slug: "jak-naplanovat-firemni-teambuilding",
    path: "/pruvodce/jak-naplanovat-firemni-teambuilding",
    title: "Jak naplánovat firemní teambuilding krok za krokem",
    description: "Praktický návod pro HR a office manažery: jak naplánovat firemní teambuilding od briefu přes rozpočet a termín až po vyhodnocení. Checklist uvnitř.",
    h1: "Jak naplánovat firemní teambuilding krok za krokem",
    excerpt: "Brief, rozpočet, termín, program, logistika — praktický plánovací checklist pro HR a office manažery.",
    author: "Tým Extreme Teambuilding",
    publishedAt: "2026-06-01",
    updatedAt: "2026-06-10",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Průvodce", href: "/pruvodce" },
      { label: "Jak naplánovat firemní teambuilding", href: "/pruvodce/jak-naplanovat-firemni-teambuilding" },
    ],
    sections: [
      {
        heading: "1. Definujte cíl, ne aktivitu",
        paras: [
          "Nejčastější chyba je vybírat aktivitu dřív, než cíl. Chcete spojit nový tým? Odměnit obchodníky za rok? Podpořit komunikaci mezi odděleními? Cíl rozhoduje o formátu — soutěžní mise, společný zážitek nebo offsite s workshopem.",
        ],
      },
      {
        heading: "2. Určete počet lidí a rozpočet",
        paras: [
          "Dvě čísla, která potřebuje každý dodavatel: počet účastníků a rozpočet na osobu. Pro představu — Mission 24 vychází orientačně od 4 990 Kč na osobu a minimální cena akce je 129 000 Kč.",
          "Počítejte s rezervou 10 % pro upsells: doprava, open bar nebo aftermovie bývají první věci, které firma přidává.",
        ],
      },
      {
        heading: "3. Zvolte termín s dostatečným předstihem",
        paras: [
          "Pro termíny na podzim a před Vánoci doporučujeme poptat 6–8 týdnů předem. Mimo sezónu stačí 3–4 týdny. Ověřte si storno podmínky a počasí — u outdoorových akcí se ptejte na weather plan.",
        ],
      },
      {
        heading: "4. Vyberte jednoho dodavatele, ne pět",
        paras: [
          "Hotel, autobus, agentura, venue, catering, bar, DJ — každý dodavatel navíc je koordinační riziko a vaše hodiny. Kompletní balíček (jako Mission 24) znamená jednu smlouvu, jednu fakturu a jednoho koordinátora.",
        ],
      },
      {
        heading: "5. Komunikujte méně, než chcete",
        paras: [
          "Pokud program obsahuje překvapení (Mission Ještěd účastníkům trasu předem neprozrazuje), sdělte lidem jen nutné: termín, sraz, oblečení. Očekávání je součást zážitku.",
        ],
      },
      {
        heading: "6. Po akci: vyhodnoťte a archivujte",
        paras: [
          "Fotografie a video z akce mají dlouhý život — interní komunikace, employer branding, nábor. Součástí Mission 24 je fotograf, večer se fotky promítají a druhý den je máte k dispozici.",
        ],
      },
    ],
    cta: { heading: "Přenechte plánování nám", text: "Stačí počet lidí, termín a rozpočet. Návrh mise připravíme na míru." },
    related: [
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/pro-firmy", title: "Pro firmy", text: "Jak spolupráce s námi probíhá." },
      { href: "/pruvodce/kolik-stoji-teambuilding", title: "Kolik stojí teambuilding", text: "Reálné ceny pro 20–50 lidí." },
    ],
  },
  {
    slug: "teambuilding-pro-30-lidi-priklad",
    path: "/pruvodce/teambuilding-pro-30-lidi-priklad",
    title: "Teambuilding pro 30 lidí: kompletní příklad programu a rozpočtu",
    description: "Konkrétní příklad teambuildingu pro 30 lidí: rozdělení do 5 týmů, hodinový harmonogram Mission 24 a orientační rozpočet 169 000 Kč.",
    h1: "Teambuilding pro 30 lidí: příklad z praxe",
    excerpt: "Pět týmů po šesti, hodinový harmonogram a rozpočet 169 000 Kč — takhle vypadá Mission 24 pro třicet lidí.",
    author: "Tým Extreme Teambuilding",
    publishedAt: "2026-06-01",
    updatedAt: "2026-06-10",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Průvodce", href: "/pruvodce" },
      { label: "Teambuilding pro 30 lidí — příklad", href: "/pruvodce/teambuilding-pro-30-lidi-priklad" },
    ],
    sections: [
      {
        heading: "Proč je 30 lidí ideální velikost",
        paras: [
          "Třicet lidí se rozdělí do pěti týmů po šesti — dost týmů na skutečnou soutěž, dost malých na to, aby se nikdo neztratil. Každý člen týmu dostane roli a průběžné pořadí pěti týmů drží napětí až do vyhlášení.",
        ],
      },
      {
        heading: "Harmonogram Mission 24 pro 30 lidí",
        paras: [
          "11:00 arrival do Warehouse Liberec, check-in a občerstvení. 12:30 briefing a rozdělení do 5 týmů. 13:00 transport na start a předání Mission Packů. 13:30–17:00 mise s checkpointy. 17:00 finish na Ještědu, týmové fotografie a finish drink. 18:00 návrat, sprchy. 19:30 večeře. 21:00 vyhlášení výsledků a promítání fotografií. 21:30–02:00 soukromá Warehouse party. Ráno snídaně 8:30–10:00 a check-out v 11:00.",
        ],
      },
      {
        heading: "Rozpočet pro 30 lidí",
        paras: [
          "Mission 24 pro 30 lidí vychází orientačně na 169 000 Kč za celou akci (5 633 Kč na osobu). V ceně: mise, 1 noc, doprava v místě, lunch/snack, finish drink, večeře, soukromý Warehouse s DJ, fotograf a snídaně.",
          "Typické upsells pro tuto velikost: autobus Praha–Liberec–Praha, open bar a aftermovie. Ceny jsou orientační, finální nabídka závisí na termínu.",
        ],
      },
      {
        heading: "Logistika pro 30 lidí",
        paras: [
          "Jeden standardní autobus vystačí na dopravu celé skupiny. Na trati pracují tři instruktoři a checkpointy se obsluhují paralelně, takže týmy nečekají ve frontách. Ubytování pro 30 lidí držíme v ověřené kapacitě tak, aby byl tým pohromadě.",
        ],
      },
    ],
    cta: { heading: "Chcete tento program pro váš tým?", text: "Stačí termín a odkud jedete. Návrh připravíme nezávazně." },
    related: [
      { href: "/teambuilding-pro-30-lidi", title: "Teambuilding pro 30 lidí", text: "Landing page pro tento formát." },
      { href: "/cenik", title: "Ceník", text: "Všechny balíčky a ceny." },
      { href: "/pruvodce/kolik-stoji-teambuilding", title: "Kolik stojí teambuilding", text: "Ceny pro 20–50 lidí." },
    ],
  },
  {
    slug: "co-si-vzit-na-outdoor-teambuilding",
    path: "/pruvodce/co-si-vzit-na-outdoor-teambuilding",
    title: "Co si vzít na outdoor teambuilding: checklist podle sezóny",
    description: "Praktický checklist vybavení na outdoor firemní teambuilding: obuv, oblečení a drobnosti pro jaro, léto, podzim i zimu. Co dostanete od nás.",
    h1: "Co si vzít na outdoor teambuilding",
    excerpt: "Checklist vybavení podle sezóny — a co už za vás vyřeší Mission Pack.",
    author: "Tým Extreme Teambuilding",
    publishedAt: "2026-06-01",
    updatedAt: "2026-06-10",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Průvodce", href: "/pruvodce" },
      { label: "Co si vzít na outdoor teambuilding", href: "/pruvodce/co-si-vzit-na-outdoor-teambuilding" },
    ],
    sections: [
      {
        heading: "Základ pro každou sezónu",
        paras: [
          "Pevná uzavřená obuv (nemusí být trekingová, stačí pevná), vrstvené oblečení, malý batoh, láhev na vodu a osobní léky. Mobil nechte v batohu — navigace je součást Mission Packu a mise se hraje bez telefonů.",
        ],
      },
      {
        heading: "Jaro a podzim",
        paras: [
          "Nepromokavá bunda je povinnost, ne doporučení. Podzimní Ještěd umí mlhu a vítr — přidejte tenkou čepici a rukavice. Oblečení, které může znečistit, protože les je les.",
        ],
      },
      {
        heading: "Léto",
        paras: [
          "Kšiltovka, opalovací krém a minimálně 1 litr vody na osobu. Dlouhé kalhoty doporučujeme i v létě — trasa vede lesem a křovím.",
        ],
      },
      {
        heading: "Zima",
        paras: [
          "Zimní mise má kratší outdoorovou část. Základ: zimní obuv, teplá bunda, čepice, rukavice a termo vrstva. Horký čaj a večerní vyhřátý Warehouse v ceně.",
        ],
      },
      {
        heading: "Co dostanete od nás",
        paras: [
          "Mission Pack obsahuje mapu, výstroj pro checkpointy a instrukce. Před akcí rozešleme účastníkům konkrétní checklist podle termínu a předpovědi — nikdo nemusí nic vymýšlet.",
        ],
      },
    ],
    cta: { heading: "Připravíme misi i checklist", text: "Stačí počet lidí, termín a rozpočet. Zbytek je na nás." },
    related: [
      { href: "/outdoor-teambuilding", title: "Outdoor teambuilding", text: "Mise v Ještědském hřbetu." },
      { href: "/pruvodce/teambuilding-kdyz-prsi", title: "Teambuilding, když prší", text: "Jak funguje weather plan." },
      { href: "/bezpecnost", title: "Bezpečnost", text: "Extreme experience, safe execution." },
    ],
  },
  {
    slug: "teambuilding-kdyz-prsi",
    path: "/pruvodce/teambuilding-kdyz-prsi",
    title: "Firemní teambuilding, když prší: jak funguje weather plan",
    description: "Co se stane s firemním teambuildingem, když prší? Mission Ještěd má weather plan: varianty trasy, kryté checkpointy a indoor backup ve Warehouse.",
    h1: "Teambuilding, když prší? Mise se neruší. Přizpůsobí se.",
    excerpt: "Weather plan v praxi: varianty trasy, kryté checkpointy a indoor backup — proto se naše akce neruší.",
    author: "Tým Extreme Teambuilding",
    publishedAt: "2026-06-01",
    updatedAt: "2026-06-10",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Průvodce", href: "/pruvodce" },
      { label: "Teambuilding, když prší", href: "/pruvodce/teambuilding-kdyz-prsi" },
    ],
    sections: [
      {
        heading: "Krátká odpověď",
        paras: [
          "Mission Ještěd se kvůli dešti neruší. Každá akce má weather plan: zkrácené varianty trasy, kryté checkpointy a v krajním případě indoor backup program přímo ve Warehouse Liberec.",
        ],
      },
      {
        heading: "Jak weather plan funguje",
        paras: [
          "Předpověď sledujeme 5 dní před akcí a finální konfiguraci trasy potvrzujeme 24–48 hodin před startem. Rozhoduje bezpečnost, ne dramaturgie — déšť sám o sobě misi nevadí, bouřka nebo ledovka ano.",
          "Varianty: plná trasa (dobré počasí), kratší trasa s krytými checkpointy (déšť), indoor+outdoor mix (silný déšť) a indoor backup ve Warehouse (extrémní počasí).",
        ],
      },
      {
        heading: "Déšť paradoxně pomáhá",
        paras: [
          "Z naší zkušenosti patří deštivé mise k těm nejsilnějším: sdílená nepohoda tým spojí víc než slunce. Fotografie z mlhy a deště mají atmosféru, kterou slunečný den nenahradí.",
          "Extrémní je zážitek, ne riziko. Bezpečnostní protokol je neměnný v každém počasí.",
        ],
      },
      {
        heading: "Co doporučujeme účastníkům",
        paras: [
          "Nepromokavá bunda a pevná obuv stačí. Konkrétní checklist podle předpovědi rozesíláme před akcí — detaily najdete v průvodci vybavením.",
        ],
      },
    ],
    cta: { heading: "Počasí nechte na nás", text: "Stačí počet lidí, termín a rozpočet. O zbytek se postaráme." },
    related: [
      { href: "/bezpecnost", title: "Bezpečnost", text: "Extreme experience, safe execution." },
      { href: "/outdoor-teambuilding", title: "Outdoor teambuilding", text: "Mise v Ještědském hřbetu." },
      { href: "/pruvodce/co-si-vzit-na-outdoor-teambuilding", title: "Co si vzít", text: "Checklist vybavení podle sezóny." },
    ],
  },
  {
    slug: "kolik-stoji-teambuilding-pro-30-lidi",
    path: "/pruvodce/kolik-stoji-teambuilding-pro-30-lidi",
    title: "Kolik stojí teambuilding pro 30 lidí? Konkrétní rozpis",
    description: "Teambuilding pro 30 lidí: kolik stojí a co je v ceně. Rozpis 169 000 Kč za Mission 24 — mise, ubytování, jídlo, party, fotograf. Orientační ceny.",
    h1: "Kolik stojí teambuilding pro 30 lidí?",
    excerpt: "Konkrétní rozpis ceny Mission 24 pro 30 lidí: 169 000 Kč a co za to přesně je.",
    author: "Tým Extreme Teambuilding",
    publishedAt: "2026-06-15",
    updatedAt: "2026-06-15",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Průvodce", href: "/pruvodce" },
      { label: "Kolik stojí teambuilding pro 30 lidí", href: "/pruvodce/kolik-stoji-teambuilding-pro-30-lidi" },
    ],
    sections: [
      { heading: "Krátká odpověď", paras: ["Mission 24 pro 30 lidí vychází orientačně na 169 000 Kč za celou akci, tedy přibližně 5 633 Kč na osobu. Jednodenní Mission bez noclehu pro 30 lidí orientačně 74 700 Kč (2 490 Kč/os.). Finální cena závisí na termínu a konfiguraci."] },
      { heading: "Co je v ceně 169 000 Kč", paras: ["Mission Ještěd s organizací a instruktory, 1 noc ubytování pro 30 lidí, doprava v místě akce, lunch/snack, finish drink, večeře, soukromý Warehouse s DJ do 02:00, fotograf po celou akci a snídaně.", "V ceně není doprava z vašeho města (umíme zajistit autobus) a upselly jako open bar, live band nebo aftermovie."] },
      { heading: "Proč cena na osobu klesá s počtem lidí", paras: ["Fixní náklady akce — Warehouse, DJ, fotograf, koordinátor — se rozpočítávají mezi účastníky. Proto 20 lidí stojí 129 000 Kč (6 450 Kč/os.) a 50 lidí 249 000 Kč (4 980 Kč/os.). Třicet lidí je ekonomicky nejefektivnější velikost pro menší firmy."] },
      { heading: "Na co si dát pozor u konkurenčních nabídek", paras: ["Porovnávejte cenu za celou akci, ne cenu aktivity. Nabídka „teambuilding od 1 500 Kč/os.“ typicky neobsahuje venue, jídlo, ubytování ani večerní program — po dokoupení skončí dráž a hlavně ji koordinujete sami."] },
    ],
    cta: { heading: "Chcete kalkulaci pro 30 lidí?", text: "Stačí termín a odkud jedete. Návrh připravíme nezávazně." },
    related: [
      { href: "/teambuilding-pro-30-lidi", title: "Teambuilding pro 30 lidí", text: "Program a logistika." },
      { href: "/cenik", title: "Ceník", text: "Všechny balíčky." },
      { href: "/pruvodce/kolik-stoji-teambuilding", title: "Kolik stojí teambuilding", text: "Obecný rozbor cen." },
    ],
  },
  {
    slug: "kolik-stoji-teambuilding-pro-50-lidi",
    path: "/pruvodce/kolik-stoji-teambuilding-pro-50-lidi",
    title: "Kolik stojí teambuilding pro 50 lidí? Konkrétní rozpis",
    description: "Teambuilding pro 50 lidí: kolik stojí a co je v ceně. Rozpis 249 000 Kč za Mission 24 — mise se 7 týmy, ubytování, party, fotograf. Orientační ceny.",
    h1: "Kolik stojí teambuilding pro 50 lidí?",
    excerpt: "Konkrétní rozpis ceny Mission 24 pro 50 lidí: 249 000 Kč a co za to přesně je.",
    author: "Tým Extreme Teambuilding",
    publishedAt: "2026-06-15",
    updatedAt: "2026-06-15",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Průvodce", href: "/pruvodce" },
      { label: "Kolik stojí teambuilding pro 50 lidí", href: "/pruvodce/kolik-stoji-teambuilding-pro-50-lidi" },
    ],
    sections: [
      { heading: "Krátká odpověď", paras: ["Mission 24 pro 50 lidí vychází orientačně na 249 000 Kč za celou akci, tedy přibližně 4 980 Kč na osobu. Finální cena závisí na termínu a konfiguraci programu."] },
      { heading: "Co je v ceně 249 000 Kč", paras: ["Mission Ještěd pro 7 týmů s intervalovými starty a čtyřmi instruktory, 1 noc ubytování pro 50 lidí, doprava v místě, lunch/snack, finish drink, večeře, soukromý Warehouse s DJ, fotograf a snídaně."] },
      { heading: "Logistika pro 50 lidí", paras: ["Padesát lidí znamená dva autobusy, intervalové starty týmů na trati a koordinované ubytování. Warehouse zůstává celý večer jen pro vaši firmu — kapacita 50 lidí je pro něj ideální."] },
      { heading: "Kdy se cena může změnit", paras: ["Finální nabídka závisí na termínu (víkend vs všední den, sezóna), konkrétním ubytování a dopravě. Padesát lidí je horní hranice standardní konfigurace — pro více lidí připravujeme individuální produkci."] },
    ],
    cta: { heading: "Chcete kalkulaci pro 50 lidí?", text: "Stačí termín a odkud jedete. Návrh připravíme nezávazně." },
    related: [
      { href: "/teambuilding-pro-50-lidi", title: "Teambuilding pro 50 lidí", text: "Program a logistika." },
      { href: "/cenik", title: "Ceník", text: "Všechny balíčky." },
      { href: "/pruvodce/kolik-stoji-teambuilding-pro-30-lidi", title: "Pro 30 lidí", text: "Rozpis pro 30 lidí." },
    ],
  },
  {
    slug: "kam-na-teambuilding-z-prahy",
    path: "/pruvodce/kam-na-teambuilding-z-prahy",
    title: "Kam na teambuilding z Prahy? Proč jet na Ještěd",
    description: "Kam na firemní teambuilding z Prahy: proč vyjet z města, co nabízí Ještěd a Liberec (orientačně 1–1,5 h po D10) a jak vypadá den s Mission Ještěd krok za krokem.",
    h1: "Kam na teambuilding z Prahy",
    excerpt: "Proč vyjet z Prahy, proč zrovna Ještěd a jak vypadá teambuildingový den pro pražskou firmu.",
    author: "Tým Extreme Teambuilding",
    publishedAt: "2026-06-15",
    updatedAt: "2026-06-15",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Průvodce", href: "/pruvodce" },
      { label: "Kam na teambuilding z Prahy", href: "/pruvodce/kam-na-teambuilding-z-prahy" },
    ],
    sections: [
      { heading: "Krátká odpověď", paras: ["Za kvalitním teambuildingem z Prahy vyjeďte — město nenabídne horu, soukromý klub a přírodu v jednom. Liberec a Ještěd jsou orientačně 1–1,5 hodiny po D10: ráno vyjedete od kanceláře, odpoledne plníte misi, večer máte Warehouse jen pro sebe."] },
      { heading: "Proč opustit Prahu", paras: ["Pražské teambuildingové aktivity sdílejí jeden problém: probíhají v prostředí, které tým zná. Změna prostředí je polovina efektu — lidé vypnou z kancelářského módu až za městem.", "Druhá polovina je exkluzivita: ve Warehouse jste jediný host večera, ne jedna z pěti firem na stejném patře."] },
      { heading: "Jak vypadá den pro pražskou firmu", paras: ["9:30 odjezd autobusem od kanceláře. 11:00 check-in ve Warehouse Liberec. 12:30 briefing. 13:30–17:00 Mission Ještěd. 19:30 večeře. 21:00 vyhlášení. 21:30–02:00 soukromá party. Druhý den snídaně a návrat do Prahy kolem oběda."] },
      { heading: "Doprava", paras: ["Vyzvedneme váš tým před kanceláří a zase ho tam vrátíme — autobus objednáme na míru skupině. Nikdo neřeší řízení po náročném dni ani parkování."] },
    ],
    cta: { heading: "Teambuilding z Prahy na klíč", text: "Stačí počet lidí, termín a rozpočet. Zbytek zařídíme." },
    related: [
      { href: "/teambuilding-praha", title: "Teambuilding Praha", text: "Landing page pro pražské firmy." },
      { href: "/teambuilding-s-dopravou", title: "Teambuilding s dopravou", text: "Door-to-door autobus." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
    ],
  },
  {
    slug: "teambuilding-s-ubytovanim-co-zajistit",
    path: "/pruvodce/teambuilding-s-ubytovanim-co-zajistit",
    title: "Teambuilding s ubytováním: co vše zajistit (checklist)",
    description: "Co zajistit u teambuildingu s ubytováním: kapacita noclehu, jídlo, doprava, večerní venue, smlouvy. Checklist + jak to řeší jeden dodavatel.",
    h1: "Teambuilding s ubytováním: co vše zajistit",
    excerpt: "Sedm dodavatelů nebo jeden. Checklist všeho, co teambuilding s noclehem potřebuje.",
    author: "Tým Extreme Teambuilding",
    publishedAt: "2026-06-15",
    updatedAt: "2026-06-15",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Průvodce", href: "/pruvodce" },
      { label: "Teambuilding s ubytováním — co zajistit", href: "/pruvodce/teambuilding-s-ubytovanim-co-zajistit" },
    ],
    sections: [
      { heading: "Krátká odpověď", paras: ["Teambuilding s ubytováním vyžaduje sedm součástí: program, nocleh pro celý tým, dopravu, jídlo, večerní venue, techniku (DJ/zvuk) a koordinaci. Buď každou řešíte zvlášť — nebo jedním balíčkem jako Mission 24."] },
      { heading: "Checklist jednotlivých součástí", paras: ["1) Program s profesionální organizací, ne DIY. 2) Nocleh pro celý tým pohromadě, ověřený předem. 3) Doprava tam i zpět včetně přesunů v místě. 4) Jídlo: lunch, večeře, snídaně + diety. 5) Soukromé večerní venue s barem. 6) DJ, zvuk, promítání. 7) Jeden koordinátor za celek."] },
      { heading: "Kde firmy nejčastěji chybují", paras: ["Nocleh objednaný jinde než večerní program — tým se po večeři rozpadne k taxíkům. Doprava jen tam, ne zpět. Večerní venue sdílené s cizími hosty. Každá z těchto chyb znehodnotí jinak dobrou akci."] },
      { heading: "Jak to řeší Mission 24", paras: ["Všech sedm součástí je v jednom balíčku od jednoho dodavatele (Warehouse club Liberec s.r.o.): mise, nocleh, doprava v místě, všechna jídla, soukromý Warehouse s DJ, fotograf. Firma má jednu smlouvu a jednoho koordinátora."] },
    ],
    cta: { heading: "Jeden dodavatel, celá akce", text: "Stačí počet lidí, termín a rozpočet." },
    related: [
      { href: "/teambuilding-s-ubytovanim", title: "Teambuilding s ubytováním", text: "Mission 24 detail." },
      { href: "/pruvodce/jak-naplanovat-firemni-teambuilding", title: "Jak naplánovat teambuilding", text: "Krok za krokem." },
      { href: "/ubytovani", title: "Ubytování", text: "Jak řešíme nocleh." },
    ],
  },
  {
    slug: "jak-vybrat-teambuilding",
    path: "/pruvodce/jak-vybrat-teambuilding",
    title: "Jak vybrat teambuilding: rozhodovací rámec pro firmy",
    description: "Jak vybrat firemní teambuilding: 5 rozhodnutí (cíl, počet lidí, rozpočet, sezóna, typ dodavatele), která určí správný formát. Praktický rámec bez omáčky.",
    h1: "Jak vybrat teambuilding: pět rozhodnutí, která stačí",
    excerpt: "Cíl, počet lidí, rozpočet, sezóna, dodavatel. Pět rozhodnutí a máte vybráno.",
    author: "Tým Extreme Teambuilding",
    publishedAt: "2026-06-15",
    updatedAt: "2026-06-15",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Průvodce", href: "/pruvodce" },
      { label: "Jak vybrat teambuilding", href: "/pruvodce/jak-vybrat-teambuilding" },
    ],
    sections: [
      { heading: "1. Cíl před aktivitou", paras: ["Nejprve odpovězte proč: spojit nový tým, odměnit výkon, prolomit bubliny oddělení, nebo poděkovat za rok? Cíl určuje formát — soutěžní mise pro spojení, večírek pro poděkování, offsite pro strategii."] },
      { heading: "2. Počet lidí", paras: ["Do 15 lidí fungují intimní formáty, 20–50 je ideální pro soutěžní týmové programy (Mission Ještěd dělí 30 lidí do 5 týmů po 6), nad 60 řešte vlnové starty a produkci."] },
      { heading: "3. Rozpočet", paras: ["Orientačně: jednodenní kvalitní teambuilding 1 500–3 000 Kč/os., s ubytováním a večerním programem 4 000–8 000 Kč/os. Mission 24: od 4 990 Kč/os. Počítejte vždy cenu celé akce, ne jen aktivity."] },
      { heading: "4. Sezóna a počasí", paras: ["Outdoor program bez weather planu je hazard. Ptejte se dodavatele: co se stane, když bude pršet? U Mission Ještěd má každá akce varianty trasy a indoor backup ve Warehouse."] },
      { heading: "5. Jeden dodavatel vs skládanka", paras: ["Hotel + autobus + agentura + venue + catering + DJ = šest smluv, šest rizik, váš týden koordinace. Kompletní balíček od jednoho dodavatele stojí podobně a riziko nesete minimálně."] },
    ],
    cta: { heading: "Nechte si navrhnout misi", text: "Stačí počet lidí, termín a rozpočet." },
    related: [
      { href: "/pruvodce/jak-naplanovat-firemni-teambuilding", title: "Jak naplánovat teambuilding", text: "Krok za krokem." },
      { href: "/pruvodce/kolik-stoji-teambuilding", title: "Kolik stojí teambuilding", text: "Reálné ceny." },
      { href: "/pro-firmy", title: "Pro firmy", text: "Jak spolupráce probíhá." },
    ],
  },
  {
    slug: "indoor-vs-outdoor-teambuilding",
    path: "/pruvodce/indoor-vs-outdoor-teambuilding",
    title: "Indoor vs outdoor teambuilding: kdy který zvolit",
    description: "Indoor nebo outdoor teambuilding? Poctivé porovnání obou formátů: počasí, kondice, zážitek, cena. A proč Mission Ještěd kombinuje obojí.",
    h1: "Indoor vs outdoor teambuilding",
    excerpt: "Kdy ven a kdy dovnitř — a proč nejsilnější formáty kombinují obojí.",
    author: "Tým Extreme Teambuilding",
    publishedAt: "2026-06-15",
    updatedAt: "2026-06-15",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Průvodce", href: "/pruvodce" },
      { label: "Indoor vs outdoor teambuilding", href: "/pruvodce/indoor-vs-outdoor-teambuilding" },
    ],
    sections: [
      { heading: "Krátká odpověď", paras: ["Outdoor teambuilding vyhrává na síle zážitku a sdíleném příběhu, indoor na předvídatelnosti a nezávislosti na počasí. Nejlepší formáty kombinují obojí: Mission Ještěd má outdoor misi s indoor weather backupem a večerním programem ve Warehouse."] },
      { heading: "Kdy outdoor", paras: ["Když chcete skutečný zážitek: pohyb, přírodu a sdílenou nepohodu, která tým spojí. Outdoor vyžaduje weather plan a úrovně obtížnosti — u kvalitního dodavatele standard, ne příplatek."] },
      { heading: "Kdy indoor", paras: ["V zimě s kratším světlem, u týmů s omezenou mobilitou, nebo když je cílem spíš workshop než zážitek. Indoor sám o sobě málokdy vytvoří historky — proto ho kombinujeme s večerním programem."] },
      { heading: "Jak to řeší Mission Ještěd", paras: ["Outdoor mise v Ještědském hřbetu + indoor backup a večerní program ve Warehouse Liberec. Při dešti se trasa zkrátí nebo přesune do krytých checkpointů — akce se neruší."] },
    ],
    cta: { heading: "Obojí v jednom", text: "Mission Ještěd kombinuje outdoor misi s Warehouse večerem." },
    related: [
      { href: "/outdoor-teambuilding", title: "Outdoor teambuilding", text: "Mise v přírodě." },
      { href: "/pruvodce/teambuilding-kdyz-prsi", title: "Když prší", text: "Weather plan v praxi." },
      { href: "/bezpecnost", title: "Bezpečnost", text: "Extreme experience, safe execution." },
    ],
  },
  {
    slug: "jak-naplanovat-firemni-offsite",
    path: "/pruvodce/jak-naplanovat-firemni-offsite",
    title: "Jak naplánovat firemní offsite: agenda, která funguje",
    description: "Jak naplánovat firemní offsite: poměr práce a zážitku (40/60), vzorová dvoudenní agenda, logistika a nejčastější chyby. Praktický návod.",
    h1: "Jak naplánovat firemní offsite",
    excerpt: "Offsite není delší porada v jiné místnosti. Pravidlo 40/60 a vzorová agenda uvnitř.",
    author: "Tým Extreme Teambuilding",
    publishedAt: "2026-06-15",
    updatedAt: "2026-06-15",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Průvodce", href: "/pruvodce" },
      { label: "Jak naplánovat firemní offsite", href: "/pruvodce/jak-naplanovat-firemni-offsite" },
    ],
    sections: [
      { heading: "Krátká odpověď", paras: ["Offsite naplánujte jako kombinaci práce a sdíleného zážitku v poměru zhruba 40/60. Práci dejte dopoledne, zážitek odpoledne, sociální program večer. Dvoudenní formát s jedním noclehem je minimum — jednodenní offsite je jen přesunutá porada."] },
      { heading: "Vzorová dvoudenní agenda", paras: ["Den 1: 9:00 příjezd, 9:30–12:30 strategický blok, 13:00 oběd, 14:00–18:00 společná aktivita (u nás Mission Ještěd), 19:30 večeře, večer volný program/party. Den 2: snídaně, 9:30–12:00 pracovní blok nebo retrospektiva, 13:00 odjezd."] },
      { heading: "Nejčastější chyby", paras: ["Příliš práce (offsite = porada v horách, tým to pozná), žádný sdílený zážitek (večer zůstane v bublinách oddělení), špatná logistika (dojíždění mezi venue a hotelem). Všechny tři řeší formát typu Mission Weekend s jedním místem pro práci, zážitek i noc."] },
      { heading: "Prostor pro práci", paras: ["Pracovní bloky potřebují klidný prostor s prezentací — ve Warehouse zajistíme zázemí pro workshop dopoledne a odpoledne se promění v základnu mise. Jeden objekt, žádné přesuny."] },
    ],
    cta: { heading: "Offsite na Ještědu", text: "Mission Weekend = práce dopoledne, mise odpoledne, party večer." },
    related: [
      { href: "/vikendovy-teambuilding", title: "Mission Weekend", text: "Dvoudenní formát s 2 noclehy." },
      { href: "/teambuilding-pro-management", title: "Pro management", text: "Offsite pro vedení." },
      { href: "/pruvodce/jak-naplanovat-firemni-teambuilding", title: "Jak naplánovat teambuilding", text: "Obecný návod." },
    ],
  },
  {
    slug: "checklist-pro-hr-teambuilding",
    path: "/pruvodce/checklist-pro-hr-teambuilding",
    title: "Checklist pro HR před firemním teambuildingem",
    description: "HR checklist před firemním teambuildingem: schválení rozpočtu, smlouva, diety, doprava, fotky a souhlasy, komunikace účastníkům. Na co nezapomenout.",
    h1: "Checklist pro HR před teambuildingem",
    excerpt: "Všechno, co HR musí vyřešit před akcí — od schválení po souhlasy s focením.",
    author: "Tým Extreme Teambuilding",
    publishedAt: "2026-06-15",
    updatedAt: "2026-06-15",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Průvodce", href: "/pruvodce" },
      { label: "Checklist pro HR", href: "/pruvodce/checklist-pro-hr-teambuilding" },
    ],
    sections: [
      { heading: "6–8 týdnů před akcí", paras: ["Schválený rozpočet a termín (vedení + kalendář firmy), poptávka u dodavatele, výběr balíčku. U podzimních a vánočních termínů neotálejte — soukromá venue mizí první."] },
      { heading: "3–4 týdny před", paras: ["Smlouva a záloha, sběr dat od účastníků: diety a alergie, velikosti (pokud brandovaná trička), dopravní preference. Komunikace účastníkům: termín, sraz, vybavení — u Mission Ještěd záměrně necelý program, překvapení je součást zážitku."] },
      { heading: "Citlivé téma: fotografie", paras: ["Fotograf na akci = skvělý materiál pro interní komunikaci i employer branding, ale: interní použití vyřešte v pozvánce, externí (web, LinkedIn) vyžaduje souhlasy. Domluvte s dodavatelem předem — my umíme fotit i „anonymní“ režim (záda, detaily, bez obličejů)."] },
      { heading: "Týden před a den D", paras: ["Finální počty dodavateli, kontakt na koordinátora akce, nouzový kontakt pro rodiny účastníků. Den D: HR nic neorganizuje — koordinátor dodavatele řídí den, vy řešíte jen případné eskalace."] },
    ],
    cta: { heading: "Předejte to nám", text: "Jeden koordinátor za vše — od nabídky po fakturu." },
    related: [
      { href: "/teambuilding-pro-hr", title: "Teambuilding pro HR", text: "Landing page pro HR." },
      { href: "/pruvodce/jak-naplanovat-firemni-teambuilding", title: "Jak naplánovat teambuilding", text: "Krok za krokem." },
      { href: "/bezpecnost", title: "Bezpečnost", text: "Bezpečnostní rámec mise." },
    ],
  },
  {
    slug: "napady-na-firemni-teambuilding",
    path: "/pruvodce/napady-na-firemni-teambuilding",
    title: "Nápady na firemní teambuilding (které fungují pro 20–50 lidí)",
    description: "Nápady na firemní teambuilding pro týmy 20–50 lidí: co skutečně funguje v praxi — týmová mise, soutěžní formáty, večerní program. Bez dětinských aktivit.",
    h1: "Nápady na firemní teambuilding, které fungují",
    excerpt: "Co opravdu funguje pro týmy 20–50 lidí — a proč většina nápadů z internetu selhává.",
    author: "Tým Extreme Teambuilding",
    publishedAt: "2026-06-15",
    updatedAt: "2026-06-15",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Průvodce", href: "/pruvodce" },
      { label: "Nápady na firemní teambuilding", href: "/pruvodce/napady-na-firemni-teambuilding" },
    ],
    sections: [
      { heading: "Proč většina nápadů selhává", paras: ["Internetové seznamy (kvízy, bowling, VR, vaření) mají společný problém: jsou to aktivity vedle sebe, ne společný zážitek. Tým se nespojí aktivitou, ale sdíleným příběhem s napětím a rozuzlením."] },
      { heading: "Co funguje: mise s příběhem", paras: ["Formát mise (mapa, checkpointy, časový limit, společný cíl) funguje, protože má dramaturgii: briefing vytvoří napětí, trasa ho drží, finish a vyhlášení ho uzavřou. Mission Ještěd je přesně tento formát — outdoorová mise pro týmy 20–50 lidí."] },
      { heading: "Co funguje: soutěž se správným scoringem", paras: ["Soutěžení motivuje, ale pozor na scoring: čistě časové soutěže vyhrávají sportovci a zbytek týmu se odpojí. Náš scoring (30 % čas, 40 % úkoly, 20 % spolupráce, 10 % bonusy) drží ve hře všechny do konce."] },
      { heading: "Co funguje: večer po misi", paras: ["Nejsilnější týmový moment není aktivita — je to večer po ní. Společná večeře, vyhlášení s promítáním fotek a soukromá party dělají z dne zážitek, který firma probírá měsíce."] },
    ],
    cta: { heading: "Chcete misi na míru?", text: "Stačí počet lidí, termín a rozpočet." },
    related: [
      { href: "/netradicni-teambuilding", title: "Netradiční teambuilding", text: "Mise s příběhem." },
      { href: "/originalni-teambuilding", title: "Originální teambuilding", text: "Proč utajení funguje." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
    ],
  },
  {
    slug: "teambuilding-jested",
    path: "/pruvodce/teambuilding-jested",
    title: "Teambuilding na Ještědu: proč je hora ideální pro firemní akci",
    description: "Teambuilding na Ještědu: co hora (1 012 m) nabízí pro firemní akce — terén Ještědského hřbetu, dostupnost z Prahy, ikonický finish pod vysílačem.",
    h1: "Teambuilding na Ještědu",
    excerpt: "Proč je Ještěd ideální hora pro firemní teambuilding — terén, dostupnost, ikona.",
    author: "Tým Extreme Teambuilding",
    publishedAt: "2026-06-15",
    updatedAt: "2026-06-15",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Průvodce", href: "/pruvodce" },
      { label: "Teambuilding na Ještědu", href: "/pruvodce/teambuilding-jested" },
    ],
    sections: [
      { heading: "Krátká odpověď", paras: ["Ještěd (1 012 m n. m.) je ideální pro firemní teambuilding, protože kombinuje skutečný horský terén s dostupností: z Prahy orientačně 1–1,5 hodiny, z Liberce pár minut. Značené trasy Ještědského hřbetu umožňují bezpečnou misi a vysílač na vrcholu je ikonický cíl."] },
      { heading: "Terén, který hraje pro misi", paras: ["Ještědský hřbet nabízí lesní cesty, hřebenovku s výhledy a přirozené orientační body. Trasa má úrovně obtížnosti — zvládne ji nesportovec i kondiční tým v náročnější variantě."] },
      { heading: "Finish, který se fotí", paras: ["Vysílač na Ještědu je nejznámější česká horská stavba. Týmová fotografie pod ním po finishi mise je obrázek, který firmy používají v interní komunikaci celý rok."] },
      { heading: "Logistika: Warehouse jako základna", paras: ["Mise startuje a končí ve Warehouse Liberec (Hanychovská 10) — check-in, sprchy, večeře i party pod jednou střechou. Na start a z vrcholu vozíme týmy organizovaným transportem."] },
    ],
    cta: { heading: "Mise na Ještěd", text: "Kompletní program Mission Ještěd pro váš tým." },
    related: [
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
      { href: "/teambuilding-liberec", title: "Teambuilding Liberec", text: "Naše domácí základna." },
      { href: "/teambuilding-v-horach", title: "Teambuilding v horách", text: "Horský formát." },
    ],
  },
];

export const GUIDES_INDEX = {
  path: "/pruvodce",
  seo: {
    title: "Průvodce firemním teambuildingem | Extreme Teambuilding",
    description: "Praktické průvodce firemním teambuildingem: ceny, plánování, vybavení, weather plan a konkrétní příklady programů pro 20–100 lidí.",
    schema: ["BreadcrumbList"],
  },
  h1: "Průvodce firemním teambuildingem",
  breadcrumbs: [
    { label: "Úvod", href: "/" },
    { label: "Průvodce", href: "/pruvodce" },
  ],
};
